import { createRouter, createWebHashHistory } from "vue-router";
import Login from "@/views/auth/Login.vue";
import Signup from "@/views/auth/Signup.vue";
import Dashboard from "@/views/Dashboard.vue";
import Profile from "@/views/auth/Profile.vue";
import ForgotPassword from "@/views/auth/forgotPassword.vue";
import ResetPassword from "@/views/auth/resetPassword.vue";

// configuration
import ClusterVue from "@/views/configurations/Cluster.vue";
// import PlantsVue from "@/views/configurations/Plants.vue";
import CreatePlant from "@/views/configurations/plant/Create.vue";
import Plants from "@/views/configurations/plant/Index.vue";

import Transporters from "@/views/configurations/Transporter.vue";
import Customers from "@/views/configurations/Customer.vue";
import Products from "@/views/configurations/Products.vue";
import Packings from "@/views/configurations/Packings.vue";
import Storages from "@/views/configurations/Storages.vue";
import LoadingTypes from "@/views/configurations/LoadingTypes.vue";
import PalletSizes from "@/views/configurations/PalletSize.vue";
import Reasons from "@/views/configurations/Reason.vue";
import Desiccants from "@/views/configurations/Desiccant.vue";
import Categories from "@/views/configurations/Category.vue";
import Items from "@/views/configurations/Item.vue";
import Suppliers from "@/views/configurations/Supplier.vue";

import CreateCheckType from "@/views/configurations/checkType/Create.vue";
import CheckTypes from "@/views/configurations/checkType/Index.vue";

import CheckListVue from "@/views/configurations/CheckList.vue";

// logs
import Logs from "@/views/logs/Index.vue";
import ViewLog from "@/views/logs/View.vue";

// user management
import Role from "@/views/userManagement/Role.vue";
import CreateUser from "@/views/userManagement/users/Create.vue";
import Users from "@/views/userManagement/users/Index.vue";
//Permissions
import Permission from "@/views/userManagement/Permission.vue";

// work order
import CreateTrip from "@/views/trip/Create.vue";
import ViewTrip from "@/views/trip/View.vue";
import Trips from "@/views/trip/Index.vue";

//pallet inspection

import CreateInspection from "@/views/palletInspection/Create.vue";
import ViewInspection from "@/views/palletInspection/View.vue";
import Inspection from "@/views/palletInspection/Index.vue";

// stages
import CreateStage from "@/views/stages/Create.vue";
import Stages from "@/views/stages/Index.vue";

// inspect stages
import CreateInspectStage from "@/views/inspectStages/Create.vue";
import InspectStages from "@/views/inspectStages/Index.vue";

// Report
import DailyReport from "@/views/reports/DailyReport.vue";
import ContainerStuffing from "@/views/reports/ContainerStuffing.vue";
import PalletReceipt from "@/views/reports/PalletReceipt.vue";

const routes = [
    {
        path: "/",
        name: "login",
        component: Login,
    },
    {
        path: "/forgot_password",
        name: "forgotPassword",
        component: ForgotPassword,
    },
    {
        path: "/reset_password",
        name: "resetPassword",
        component: ResetPassword,
    },
    {
        path: "/signup",
        name: "Signup",
        component: Signup,
    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
    },

    // configuration

    {
        path: "/clusters",
        name: "Cluster",
        component: ClusterVue,
    },
    // {
    //   path: "/plants",
    //   name: "Plant",
    //   component: PlantsVue,
    // },
    // plants
    {
        path: "/plants",
        name: "Plants.Index",
        component: Plants,
    },
    {
        path: "/plants/create",
        name: "Plants.Create",
        component: CreatePlant,
    },
    {
        path: "/plants/:plant_id/edit",
        name: "Plant.Edit",
        component: CreatePlant,
    },

    // checktypes
    {
        path: "/checktypes",
        name: "CheckTypes.Index",
        component: CheckTypes,
    },
    {
        path: "/checktypes/create",
        name: "CheckTypes.Create",
        component: CreateCheckType,
    },
    {
        path: "/checktypes/:check_type_id/edit",
        name: "CheckType.Edit",
        component: CreateCheckType,
    },

    {
        path: "/check_list",
        name: "CheckList",
        component: CheckListVue,
    },
    {
        path: "/transporters",
        name: "Transporters",
        component: Transporters,
    },
    {
        path: "/customers",
        name: "Customers",
        component: Customers,
    },
    {
        path: "/storages",
        name: "Storages",
        component: Storages,
    },
    {
        path: "/products",
        name: "Products",
        component: Products,
    },
    {
        path: "/packings",
        name: "Packings",
        component: Packings,
    },
    {
        path: "/loading_types",
        name: "LoadingTypes",
        component: LoadingTypes,
    },
    {
        path: "/pallet_sizes",
        name: "PalletSizes",
        component: PalletSizes,
    },
    {
        path: "/reason",
        name: "Reasons",
        component: Reasons,
    },

    {
        path: "/desiccant",
        name: "Desiccants",
        component: Desiccants,
    },
    {
        path: "/category",
        name: "Categories",
        component: Categories,
    },
    {
        path: "/item",
        name: "Items",
        component: Items,
    },
    {
        path: "/suppliers",
        name: "Suppliers",
        component: Suppliers,
    },

    // user management
    {
        path: "/role",
        name: "Role",
        component: Role,
    },
    // users
    {
        path: "/users",
        name: "Users.Index",
        component: Users,
    },
    {
        path: "/users/create",
        name: "Users.Create",
        component: CreateUser,
    },
    {
        path: "/users/:user_id/edit",
        name: "User.Edit",
        component: CreateUser,
    },

    // Logs
    {
        path: "/logs",
        name: "Logs.Index",
        component: Logs,
    },
    {
        path: "/logs/:log_id/view",
        name: "Log.View",
        component: ViewLog,
    },
    // Permissions
    {
        path: "/permissions",
        name: "Permissions",
        component: Permission,
    },

    // work order
    {
        path: "/trips",
        name: "Trip.Index",
        component: Trips,
    },
    {
        path: "/trip/create",
        name: "Trip.Create",
        component: CreateTrip,
    },
    {
        path: "/trip/:trip_id/edit",
        name: "Trip.Edit",
        component: CreateTrip,
    },
    {
        path: "/trip/:trip_id/view",
        name: "Trip.View",
        component: ViewTrip,
    },
    //pallet inspection
    {
        path: "/pallet_inspections",
        name: "PalletInspection.Index",
        component: Inspection,
    },
    {
        path: "/pallet_inspection/create",
        name: "Inspection.Create",
        component: CreateInspection,
    },
    {
        path: "/pallet_inspection/:inspection_id/edit",
        name: "Inspection.Edit",
        component: CreateInspection,
    },
    {
        path: "/pallet_inspection/:inspection_id/view",
        name: "Inspection.View",
        component: ViewInspection,
    },

    // stages

    {
        path: "/stages",
        name: "Stages.Index",
        component: Stages,
    },
    {
        path: "/stages/create",
        name: "Stages.Create",
        component: CreateStage,
    },
    {
        path: "/stages/:stage_id/edit",
        name: "Stages.Edit",
        component: CreateStage,
    },
    // inspect stages
    {
        path: "/inspectstages",
        name: "InspectStages.Index",
        component: InspectStages,
    },
    {
        path: "/inspectStages/create",
        name: "InspectStages.Create",
        component: CreateInspectStage,
    },
    {
        path: "/inspectStages/:inspect_stage_id/edit",
        name: "InspectStages.Edit",
        component: CreateInspectStage,
    },

	// reports
	{
		path: "/daily_report",
		name: "DailyReport",
		component: DailyReport,
	},
    {
		path: "/container_stuffing",
		name: "ContainerStuffing",
		component: ContainerStuffing,
	},
    {
		path: "/pallet_receipt",
		name: "PalletReceipt",
		component: PalletReceipt,
	},
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
